import { ScrollView, StyleSheet, Text, Pressable, Linking } from "react-native";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon, tabIconSize, logError, os } from "../platform";
import SEOHeaderTags from "../components/SEOHeaderTags";
import AppStore from "../storage/appStore";
import { COLORS } from "../theme/colors";
import { STRINGS } from "../constants/strings";

const Settings = ({ navigation }) => {
  const setErrorMessage = AppStore((state) => state.setErrorMessage);

  return (
    <ScrollView contentContainerStyle={styles.container}>
      <SEOHeaderTags style={styles.headerText} text={STRINGS.feedbackAndHelp} tag="h2" />
      <Pressable
        style={[styles.pressableStyle, styles.itemStyle]}
        onPress={async () => {
          try {
            if (os === "web") {
              await Linking.openURL(STRINGS.seamlessLink);
            } else {
              navigation.navigate("WebViewScreen", { url: STRINGS.seamlessLink, title: STRINGS.submitFeedback });
            }
          } catch (error) {
            logError("seamless_link_failed", {
              message: error.message,
              stack: error.stack,
              url: STRINGS.seamlessLink
            });
            setErrorMessage(STRINGS.failedToOpenLink);
          }
        }}
        accessible={true}
        accessibilityRole="button"
        accessibilityLabel={STRINGS.submitFeedback}
      >
        <Text style={styles.itemText} maxFontSizeMultiplier={1.2}>
          {STRINGS.submitFeedback}
        </Text>
        <FontAwesomeIcon icon={faChevronRight} size={tabIconSize} color={COLORS.tertiary} />
      </Pressable>

      <SEOHeaderTags style={styles.headerText} text={STRINGS.about} tag="h2" />
      <Text
        style={[styles.itemStyle, styles.itemText]}
        accessible={true}
        accessibilityRole="text"
        maxFontSizeMultiplier={1.2}
      >
        {STRINGS.version}
      </Text>
      <Pressable
        style={[styles.pressableStyle, styles.itemStyle]}
        onPress={() => navigation.navigate("Terms")}
        accessible={true}
        accessibilityRole="button"
        accessibilityLabel={STRINGS.termsOfService}
      >
        <Text style={styles.itemText} maxFontSizeMultiplier={1.2}>
          {STRINGS.termsOfService}
        </Text>
        <FontAwesomeIcon icon={faChevronRight} size={tabIconSize} color={COLORS.tertiary} />
      </Pressable>

      <SEOHeaderTags style={styles.headerText} text={STRINGS.moreInfo} tag="h2" />
      <Pressable
        style={[styles.pressableStyle, styles.itemStyle]}
        onPress={async () => {
          try {
            if (os === "web") {
              await Linking.openURL(STRINGS.moreAppsLink);
            } else {
              navigation.navigate("WebViewScreen", { url: STRINGS.moreAppsLink, title: STRINGS.viewOurOtherApps });
            }
          } catch (error) {
            logError("more_apps_link_failed", {
              message: error.message,
              stack: error.stack,
              url: STRINGS.moreAppsLink
            });
            setErrorMessage(STRINGS.failedToOpenLink);
          }
        }}
        accessible={true}
        accessibilityRole="button"
        accessibilityLabel={STRINGS.viewOurOtherApps}
      >
        <Text style={styles.itemText} maxFontSizeMultiplier={1.2}>
          {STRINGS.viewOurOtherApps}
        </Text>
        <FontAwesomeIcon icon={faChevronRight} size={tabIconSize} color={COLORS.tertiary} />
      </Pressable>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    width: "100%",
    maxWidth: 750,
    alignSelf: "center",
    paddingHorizontal: 20,
    paddingBottom: 50,
    backgroundColor: COLORS.background,
  },
  pressableStyle: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerText: {
    fontSize: 21,
    padding: 5,
    paddingTop: 30,
    paddingBottom: 10,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderColor: COLORS.borderDark,
  },
  itemStyle: {
    paddingTop: 25,
    marginLeft: 20,
    paddingBottom: 15,
    borderBottomWidth: 1,
    borderColor: COLORS.borderDark,
  },
  itemText: {
    fontSize: 17,
  },
});

export default Settings;
